import AIOptionPart from "../../components/new/AIOptionPart";

// OptionPopupPage.tsx
export default function OptionPopupPage() {
  const searchParams = new URLSearchParams(window.location.search);
  const trainUuid = searchParams.get("trainUuid");

  return (
    <div style={{ height: "100vh" }}>
      {/* <AIOptionPart trainUuid={trainUuid || ""} isOpenOption={false} /> */}
    </div>
  );
}
